// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__11HOG","box":"WorkspacesBox_box__DVZFZ","node":"WorkspacesBox_node__90kOn"};